module.exports = __webpack_public_path__ + "media/shippy/phone-b007d82c.svg";